import { defineComponent, computed } from "vue";
import Icon from "./component-library248.mjs";
import LinkButton from "./component-library3.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "energy-label-icon",
  props: {
    energyClass: null,
    reverse: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    const title = computed(() => {
      return `Energieeffizienz ${props.energyClass}`;
    });
    const emitClick = (e) => {
      emit("click", e);
    };
    return { __sfc: true, props, emit, title, emitClick, Icon, LinkButton };
  }
});
export {
  _sfc_main as default
};
